/* eslint-disable import/prefer-default-export */
import { useBusinessApi } from './business';
import useShopApi from './ecommerce/shop';
import useStoreApi from './store/settings';
import useAccountingApi from './accounting';

export const useSettingsApi = () => {
  const ShopsApi = useShopApi();
  const BusinessApi = useBusinessApi();
  const StoreApi = useStoreApi();
  const AccountingApi = useAccountingApi();
  return { ShopsApi, StoreApi, BusinessApi, AccountingApi };
};
